import api from "../../api.js";

export async function getInventoryLevels({ fromDate, toDate } = {}) {
  const params = {};

  if (fromDate instanceof Date && !isNaN(fromDate.getTime())) {
    params.from = fromDate.toISOString();
  }

  if (toDate instanceof Date && !isNaN(toDate.getTime())) {
    params.to = toDate.toISOString();
  }

  const res = await api.get("/api/analytics/inventory-levels", { params });
  return res.data?.data || [];
}

export async function getReturnRate({ fromDate, toDate } = {}) {
  const params = {};

  if (fromDate instanceof Date && !isNaN(fromDate.getTime())) {
    params.from = fromDate.toISOString();
  }

  if (toDate instanceof Date && !isNaN(toDate.getTime())) {
    params.to = toDate.toISOString();
  }

  const res = await api.get("/api/analytics/return-rate", { params });
  return res.data?.data || [];
}

export async function getExpiredStock({ fromDate, toDate } = {}) {
  const params = {};

  if (fromDate instanceof Date && !isNaN(fromDate.getTime())) {
    params.from = fromDate.toISOString();
  }

  if (toDate instanceof Date && !isNaN(toDate.getTime())) {
    params.to = toDate.toISOString();
  }

  const res = await api.get("/api/analytics/expired-stock", { params });
  return res.data?.data || [];
}

export async function getTopSellingMedications({ fromDate, toDate } = {}) {
  const params = {};

  if (fromDate instanceof Date && !isNaN(fromDate.getTime())) {
    params.from = fromDate.toISOString();
  }

  if (toDate instanceof Date && !isNaN(toDate.getTime())) {
    params.to = toDate.toISOString();
  }

  const res = await api.get("/api/analytics/top-selling-medications", { params });
  return res.data?.data || [];
}

export async function getTotalBranches() {
  const res = await api.get("/api/analytics/total-branches");
  return typeof res.data?.data === "number" ? res.data.data : 0;
}

export async function getExpiredStockKpi() {
  const res = await api.get("/api/analytics/expired-stock-kpi");
  return res.data?.data || {
    totalExpiredStock: 0,
    expiredAcrossBranches: 0,
    nearingExpiryStock: 0,
  };
}

export async function getLowStockKpi() {
  const res = await api.get("/api/analytics/low-stock-kpi");
  return res.data?.data || {
    totalLowStock: 0,
    lowAcrossBranches: 0,
    criticalStock: 0,
  };
}

export async function getSalesByBranch() {
  const res = await api.get("/api/analytics/sales-by-branch");
  return res.data?.data || [];
}

export async function getTotalInventory() {
  const res = await api.get("/api/analytics/total-inventory");
  return res.data?.data?.totalInventory ?? 0;
}

export async function getTotalInventoryValue() {
  const res = await api.get("/api/analytics/total-inventory-value");
  return res.data?.data?.totalInventoryValue ?? 0;
}